import { ButtonLink } from "design-system/atoms/Button"

import { Outlet } from "@tanstack/react-router"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Pencil } from "lucide-react"
import { useFrontAppIntegrationQuery } from "modules/settings/hooks/frontapp/useFrontAppIntegrationQuery"
import { Loading } from "modules/shared/components/Loading"
import { useTranslation } from "react-i18next"

export const FrontAppIntegration = () => {
  const { t } = useTranslation()
  const { data, isPending } = useFrontAppIntegrationQuery()

  if (isPending) {
    return <Loading />
  }

  const hasConfiguration = !!data

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row gap-4 p-4">
          <div className="grow flex flex-col gap-1">
            <CardTitle>{t("settings.integrations.frontapp.integrationCard.title")}</CardTitle>
            <CardDescription>
              {hasConfiguration
                ? t("settings.integrations.frontapp.integrationCard.descriptionDone")
                : t("settings.integrations.frontapp.integrationCard.descriptionPending")}
            </CardDescription>
          </div>
          <div className="flex items-center">
            {hasConfiguration ? (
              <div className="flex gap-2">
                <BadgePingText
                  color={"success"}
                  text={t("settings.integrations.frontapp.integrationCard.connected")}
                />
                <ButtonLink
                  variant={"ghost"}
                  size="icon"
                  to="/settings/integrations/frontapp/connect"
                >
                  <Pencil />
                </ButtonLink>
              </div>
            ) : (
              <ButtonLink to={"/settings/integrations/frontapp/connect"}>
                {t("settings.integrations.frontapp.integrationCard.configButton")}
              </ButtonLink>
            )}
          </div>
        </CardHeader>
      </Card>
      <Outlet />
    </>
  )
}
